<template>
  <div class="app-container">
    <div class="filter-container">
      <el-tabs type="border-card">
        <el-tab-pane>
          <span slot="label">
            <i class="el-icon-date" /> 基本资料
          </span>
          <el-form
            ref="childDataForm"
            :inline="true"
            :rules="rules"
            :model="temp"
            class="demo-form-inline"
            label-position="right"
            label-width="150px"
          >
            <el-form-item :label="$t('member.memberName')" prop="memberName">
              <el-input v-model="temp.memberName" maxlength="20" />
            </el-form-item>
            <el-form-item :label="$t('member.phoneNum')" prop="phoneNum">
              <el-input v-model="temp.phoneNum" maxlength="20" />
            </el-form-item>
            <el-form-item :label="$t('member.timesUpperLimit')" prop="timesUpperLimit">
              <el-input v-model.number="temp.timesUpperLimit" maxlength="7" />
            </el-form-item>
            <el-form-item :label="$t('company.memberGrade')" prop="memberGradeId">
              <el-select
                v-model="temp.memberGradeId"
                :disabled="disableGrade"
                class="filter-item"
                placeholder="请选择"
                @change="bindChange"
              >
                <el-option
                  v-for="(item,index) in gradeLists"
                  :key="index"
                  :label="item.gradeName"
                  :value="item.gradeId"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('member.dailyUpperLimit')" prop="dailyUpperLimit">
              <el-input v-model.number="temp.dailyUpperLimit" maxlength="7" />
            </el-form-item>
            <el-form-item :label="$t('member.monthUpperLimit')" prop="monthUpperLimit">
              <el-input v-model.number="temp.monthUpperLimit" maxlength="7" />
            </el-form-item>
            <el-form-item :label="$t('member.cardNo')" prop="cardNo">
              <el-input v-model="temp.cardNo" maxlength="8" />
            </el-form-item>
            <el-form-item
              v-if="(!temp.companyId || temp.companyId <= 0) && componentType === 'retail'"
              :label="$t('company.companyName')"
              prop="companyId"
            >
              <el-select :disabled="true" placeholder="无" style="width:190px" />
            </el-form-item>
            <el-form-item v-else :label="$t('company.companyName')" prop="companyId">
              <el-select
                v-model="temp.companyId"
                :disabled="disableCompany"
                class="filter-item"
                placeholder="请选择"
                @change="bindCompany"
              >
                <el-option
                  v-for="(item,index) in companyLists"
                  :key="index"
                  :label="item.companyName"
                  :value="item.companyId"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="isAllStation==0" label="所属油站" required>
              <el-input v-model="temp.stationName" maxlength="10" disabled />
            </el-form-item>
            <el-form-item v-else label="所属油站" prop="optStationId">
              <el-select
                v-model="temp.optStationId"
                class="filter-item"
                placeholder="请选择"
                @change="selectStations()"
              >
                <el-option
                  v-for="(item,index) in stationLists"
                  :key="index"
                  :label="item.stationName"
                  :value="item.stationId"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('member.carNo')" prop="carNo">
              <el-input v-model="temp.carNo" maxlength="10" />
            </el-form-item>
            <el-form-item :label="$t('member.birthday')" prop="birthday">
              <el-input v-model="temp.birthday" maxlength="20" />
            </el-form-item>
            <el-form-item :label="$t('member.idCard')" prop="idCard">
              <el-input v-model="temp.idCard" maxlength="20" />
            </el-form-item>
            <el-form-item :label="$t('member.memo')" prop="memo">
              <el-input v-model="temp.memo" maxlength="50" />
            </el-form-item>
            <el-form-item label="车环号">
              <el-input v-model="temp.carRing" :disabled="carRingEnableDisab" maxlength="100" />
            </el-form-item>
            <el-row :gutter="18">
              <el-col :span="6">
                <el-form-item prop="checkFuelPwd">
                  <el-checkbox
                    v-model="memberCheckFlags.checkFuelPwd"
                    name="checkFuelPwd"
                    @change="handleCheck"
                  >{{ $t('member.checkFuelPwd') }}</el-checkbox>
                  <el-input
                    v-model="temp.fuelPwd"
                    :disabled="!memberCheckFlags.checkFuelPwd"
                    maxlength="6"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label=" " prop="checkCarNo">
                  <el-checkbox
                    v-model="memberCheckFlags.checkCarNo"
                    style="margin-left:80%"
                    name="checkCarNo"
                    border
                    size="medium"
                    @change="handleCheck"
                  >限车牌</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="6" style="padding-left:5%">
                <!--                <el-form-item label=" " prop="checkEmpCard">
                  <el-checkbox
                    v-model="memberCheckFlags.checkEmpCard"
                    style="margin-left:80%"
                    name="checkEmpCard"
                    border
                    size="medium"
                    @change="handleCheck"
                  >校验员工卡</el-checkbox>
                </el-form-item>-->
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="用户权限">
          <el-form>
            <el-row :gutter="4">
              <el-col :span="8">
                <el-form-item prop="fuelStations">
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="memberCheckFlags.checkAllConsume"
                    name="isAllFuel"
                    @change="handleCheckAllChange"
                  >全选({{ $t('member.isAllFuel') }})</el-checkbox>
                  <el-main style="height: 200px;padding-left:0px">
                    <el-checkbox-group
                      v-model="tempFuelStations"
                      @change="handleCheckedCitiesChange"
                    >
                      <el-checkbox
                        v-for="item in stationLists"
                        :label="item.stationId"
                        :key="item.stationId"
                      >{{ item.stationName }}</el-checkbox>
                    </el-checkbox-group>
                  </el-main>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="chargeStations">
                  <el-checkbox
                    :indeterminate="isIndeterminate2"
                    v-model="memberCheckFlags.checkAllRecharge"
                    name="isAllCharge"
                    @change="handleCheckAllChange"
                  >全选({{ $t('member.isAllCharge') }})</el-checkbox>
                  <el-main style="height: 200px;padding-left:0px">
                    <el-checkbox-group
                      v-model="tempChargeStations"
                      @change="handleCheckedCitiesChange2"
                    >
                      <el-checkbox
                        v-for="item in stationLists"
                        :label="item.stationId"
                        :key="item.stationId"
                      >{{ item.stationName }}</el-checkbox>
                    </el-checkbox-group>
                  </el-main>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="oilProds">
                  <el-checkbox
                    :indeterminate="isIndeterminate3"
                    v-model="memberCheckFlags.checkAllProds"
                    name="isAllProds"
                    @change="handleCheckAllProds"
                  >全选(全部油品)</el-checkbox>
                  <el-main style="width:300px;height: 200px;margin-left:20px;padding-left:10px">
                    <el-checkbox-group v-model="tempProdList" @change="handleCheckedCitiesChange3">
                      <el-checkbox
                        v-for="item in prodLists"
                        :label="item.prodId"
                        :key="item.prodId"
                      >{{ item.prodName }}</el-checkbox>
                    </el-checkbox-group>
                  </el-main>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div style="margin-left: 650px;margin-top: 20px">
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleCancel">{{ $t('table.cancel') }}</el-button>
          <el-button
            v-if="componentType=='childAdd' || componentType=='memberAdd'"
            type="primary"
            @click="createData"
          >{{ $t('table.confirm') }}</el-button>
          <el-button
            v-if="componentType=='childEdit' || componentType=='memberEdit'"
            type="primary"
            @click="updateData"
          >{{ $t('table.confirm') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gradeList } from '@/api/grade'
import { listProd } from '@/api/product'
import { stationList } from '@/api/station'
import { createMember, updateMember } from '@/api/member'
import { isNumber } from '@/utils/validate'
import { fetchList } from '@/api/company'
import waves from '@/directive/waves' // 水波纹指令
const componentType = ['childAdd', 'childEdit', 'memberAdd', 'memberEdit']
import { getEmpInfo } from '../../utils/auth'
const empinfo = getEmpInfo()
export default {
  name: 'NewChildMember',
  directives: {
    waves
  },
  props: {
    companyId: {
      type: Number,
      required: true
    },
    companyName: {
      type: String,
      required: true
    },
    gradeId: {
      type: Number,
      required: true
    }
  },
  data () {
    const checkPWD = (rule, value, callback) => {
      if (this.temp.checkFuelPwd && !value) {
        return callback(new Error('加油密码不能为空'))
      }
      callback()
    }
    const checkPhone = (rule, value, callback) => {
      if (!isNumber(value) || String(value).length < 8) {
        callback(new Error('请输入正确电话'))
      } else {
        callback()
      }
    }
    const checkfuelStations = (rule, value, callback) => {
      if (!this.temp.isAllFuel && value.length === 0) {
        return callback(new Error('消费站点必须选择'))
      }
      callback()
    }
    const checkchargeStations = (rule, value, callback) => {
      if (!this.temp.isAllCharge && value.length === 0) {
        return callback(new Error('充值站点必须选择'))
      }
      callback()
    }
    return {
      disableCompany: true,
      disableGrade: true,
      componentType: componentType[0],
      dialogStatus: '',
      isIndeterminate: true,
      isIndeterminate2: true,
      isIndeterminate3: false,
      companyLists: [],
      stationLists: [],
      checkAll: true,
      stationValues: [],
      checkAll2: true,
      listLoading: true,
      tempFuelStations: [],
      tempChargeStations: [],
      tempProdList: [],
      prodLists: [],
      prodIdList: [],
      prodNameList: [],
      memberCheckFlags: {
        checkFuelPwd: false,
        checkCarNo: false,
        checkEmpCard: false,
        checkAllConsume: false,
        checkAllRecharge: false,
        checkAllProds: true
      },
      temp: {
        memberType: '1',
        memberId: 0,
        phoneNum: '',
        memberName: '',
        memberGradeId: '',
        memberGradeName: '',
        cardNo: '',
        carNo: '',
        timesUpperLimit: 9999.99,
        dailyUpperLimit: 9999.99,
        monthUpperLimit: 9999.99,
        checkCarNo: '',
        checkEmpCard: '',
        checkFuelPwd: false,
        fuelPwd: '',
        isAllFuel: false,
        fuelStations: [],
        isAllCharge: false,
        isAllProd: 1,
        allowProd: [],
        chargeStations: [],
        memo: '',
        birthday: '',
        idCard: '',
        companyId: 0,
        companyName: '',
        stationName: '',
        optStationId: '',
        carRing: ''
      },
      rules: {
        monthUpperLimit: [
          {
            type: 'number',
            required: true,
            message: '必须填写，且大于0',
            min: 0,
            trigger: 'blur'
          }
        ],
        dailyUpperLimit: [
          {
            type: 'number',
            required: true,
            message: '必须填写，且大于0',
            trigger: 'blur',
            min: 0
          }
        ],
        timesUpperLimit: [
          {
            type: 'number',
            required: true,
            message: '必须填写，且大于0',
            trigger: 'blur',
            min: 0
          }
        ],
        memberName: [
          { required: true, message: '必须填写', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        phoneNum: [
          { required: true, message: '必须填写', trigger: 'blur' },
          {
            min: 8,
            max: 20,
            message: '长度在 7 到 50 个字符,且为数字',
            trigger: 'blur',
            validator: checkPhone
          }
        ],
        cardNo: [
          { required: false, message: '必须填写', trigger: 'blur' },
          { min: 8, max: 10, message: '长度在 8 到 10 个字符', trigger: 'blur' }
        ],
        memberGradeId: [
          { required: true, message: '必须填写', trigger: 'change' }
        ],
        fuelPwd: [{ validator: checkPWD, trigger: 'blur' }],
        fuelStations: [
          {
            type: 'array',
            required: true,
            validator: checkfuelStations,
            trigger: 'change'
          }
        ],
        chargeStations: [
          {
            type: 'array',
            required: true,
            validator: checkchargeStations,
            trigger: 'change'
          }
        ],
        optStationId: [
          { required: true, message: '请选择所属站点', trigger: 'change' }
        ]
      },
      gradeLists: [],
      dialogFormVisible: false,
      isAllStation: empinfo.isAllStation, // 是否开户至登录账号油站
      carRingEnableDisab: false
    }
  },
  created () {
    console.log(empinfo)
    if (empinfo.isAllStation == 0) {
      this.temp.optStationId = empinfo.stationId
      this.temp.stationName = empinfo.stationName
    }
    const routeName = this.$route.name
    if (routeName === 'manager') {
      this.componentType = componentType[0]
    }
    listProd({}).then((response, err) => {
      if (err) {
        console.log('prodErr', err)
      }
      this.prodLists = response.data.data
      for (let i = 0; i < this.prodLists.length; i++) {
        this.prodNameList[i] = this.prodLists[i].prodName
        this.prodIdList[i] = this.prodLists[i].prodId
      }
      this.tempProdList = this.prodIdList
    })
    gradeList({ ps: 100 }).then(response => {
      const row = response.data
      if (row.data) {
        const obj = row.data
        for (const key in obj) {
          this.gradeLists.push({
            gradeId: obj[key].gradeId,
            gradeName: obj[key].gradeName
          })
        }
      }
    })
    stationList({ ps: 100 }).then(response => {
      const row = response.data
      if (row.data.items) {
        const obj = row.data.items
        for (const key in obj) {
          this.stationLists.push({
            stationId: obj[key].stationId,
            stationName: obj[key].stationName,
            carRingEnable: obj[key].carRingEnable
          })
          this.stationValues.push(obj[key].stationId)
        }
        this.tempChargeStations = this.stationValues
        this.tempFuelStations = this.stationValues
        this.isIndeterminate =
          this.tempFuelStations.length > 0 &&
          this.tempFuelStations.length < this.stationValues.length
        this.isIndeterminate2 =
          this.tempChargeStations.length > 0 &&
          this.tempChargeStations.length < this.stationValues.length
      }
    })
    fetchList({ ps: 100 }).then(response => {
      const row = response.data
      if (row.data.items) {
        const obj = row.data.items
        for (const key in obj) {
          this.companyLists.push({
            companyId: obj[key].companyId,
            companyName: obj[key].companyName
          })
        }
      }
    })
    this.temp.memberGradeId = this.gradeId
    this.temp.companyId = this.companyId
    this.temp.companyName = this.companyName
    this.memberCheckFlags.checkAllRecharge = true
    this.memberCheckFlags.checkAllConsume = true
  },
  methods: {
    bindChange (gradeId) {
      if (this.componentType.indexOf('child' > 0)) {
        this.disableCompany = true
      } else {
        this.disableCompany = false
      }
      this.temp.memberGradeId = gradeId
    },
    handleCheck (val, event) {
      if (event.target.name === 'checkFuelPwd') {
        this.temp.checkFuelPwd = val
        this.bool = !val
      } else if (event.target.name === 'checkCarNo') {
        this.temp.checkCarNo = val
      } else {
        this.temp.checkEmpCard = val
      }
    },
    handleCheckAllChange (val, event) {
      if (event.target.name === 'isAllFuel') {
        this.tempFuelStations = val ? this.stationValues : []
        this.isIndeterminate = false
      } else {
        this.tempChargeStations = val ? this.stationValues : []
        this.isIndeterminate2 = false
      }
    },
    handleCheckedCitiesChange (value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.stationLists.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.stationLists.length
    },
    handleCheckedCitiesChange2 (value) {
      const checkedCount = value.length
      this.checkAll2 = checkedCount === this.stationLists.length
      this.isIndeterminate2 =
        checkedCount > 0 && checkedCount < this.stationLists.length
    },
    createData () {
      this.$refs['childDataForm'].validate(valid => {
        if (valid) {
          if (this.componentType.indexOf('child') > 0) {
            this.temp.memberType = 2
          } else {
            this.temp.memberType = 1
          }
          const obj = this.gradeLists.find(
            o => o.gradeId === this.temp.memberGradeId
          )
          this.temp.memberGradeId = obj.gradeId
          this.temp.memberGradeName = obj.gradeName
          this.temp.fuelStations = this.tempFuelStations.join(',')
          this.temp.chargeStations = this.tempChargeStations.join(',')
          this.temp.allowProd = this.tempProdList.join(',')
          this.temp.isAllCharge = this.memberCheckFlags.checkAllRecharge ? 1 : 0
          this.temp.isAllFuel = this.memberCheckFlags.checkAllConsume ? 1 : 0
          this.temp.checkEmpCard = this.memberCheckFlags.checkEmpCard ? 1 : 0
          this.temp.checkCarNo = this.memberCheckFlags.checkCarNo ? 1 : 0
          this.temp.checkFuelPwd = this.memberCheckFlags.checkFuelPwd ? 1 : 0
          this.temp.isAllProd = this.memberCheckFlags.checkAllProds ? 1 : 0
          // return
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          createMember(this.temp)
            .then(res => {
              loading.close()
              this.$emit('dialogEmp', false)
              this.$emit('createdData', true)
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000
              })
            })
            .catch(() => {
              loading.close()
            })
        }
      })
    },
    bindCompany (selVal) {
      if (this.componentType.indexOf('child' > 0)) {
        this.disableCompany = true
      } else {
        this.disableCompany = false
      }
      const company = this.companyLists.find(item => item.companyId === selVal)
      // this.temp.companyName = this.companyLists[selVal].companyName
      if (company) {
        this.temp.companyId = company.companyId
        this.temp.companyName = company.companyName
      } else {
        this.temp.companyId = 0
        this.temp.companyName = ''
      }
    },
    updateData () {
      this.$refs['childDataForm'].validate(valid => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          tempData.fuelStations = this.tempFuelStations.join(',')
          tempData.chargeStations = this.tempChargeStations.join(',')
          tempData.checkCarNo = this.memberCheckFlags.checkCarNo ? 1 : 0
          tempData.checkFuelPwd = this.memberCheckFlags.checkFuelPwd ? 1 : 0
          tempData.checkEmpCard = this.memberCheckFlags.checkEmpCard ? 1 : 0
          tempData.isAllCharge = this.memberCheckFlags.checkAllRecharge ? 1 : 0
          tempData.isAllFuel = this.memberCheckFlags.checkAllConsume ? 1 : 0
          updateMember(tempData).then(() => {
            this.$emit('dialogEmp', false)
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleCheckAllProds (val) {
      if (val) {
        this.memberCheckFlags.checkAllProds = true
        this.tempProdList = this.prodIdList
      } else {
        this.memberCheckFlags.checkAllProds = false
        this.tempProdList = []
      }
      this.isIndeterminate3 = false
    },
    handleCheckedCitiesChange3 (value) {
      const checkedCount = value.length
      this.memberCheckFlags.checkAllProds =
        checkedCount === this.prodIdList.length
      this.isIndeterminate3 =
        checkedCount > 0 && checkedCount < this.prodLists.length
    },
    handleCancel () {
      this.$emit('dialogEmp', false)
    },
    selectStations () {
      console.log(this.temp.optStationId)
      console.log(this.stationLists)
      for (const i in this.stationLists) {
        if (this.temp.optStationId === this.stationLists[i].stationId) {
          if (this.stationLists[i].carRingEnable === 0) {
            this.carRingEnableDisab = true
          } else {
            this.carRingEnableDisab = false
          }
          console.log(this.carRingEnableDisab)
          return
        }
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.grid-content {
  padding: 10px 0px;
}
.el-checkbox {
  margin-right: 30px;
}
.el-checkbox + .el-checkbox {
  margin-left: 0px;
}
.el-row {
  padding-left: 15%;
}
</style>
